<template lang="pug">
  .flex-centered.content-full-height(v-if="loading") #[.loading.loading-lg]
  .columns(v-else-if="report")
    .column.col-6.col-sm-12.my-2
      watched-time-card(:seconds-watched="report.secondsWatched")
    .column.col-6.col-sm-12.my-2
      retention-card(:retention="report.retention")
    .column.col-12.divider.my-2
    .column.col-12.my-2
      most-viewed-card(:most-viewed-items="report.mostViewedProductItems")
    .column.col-12.divider.my-2
    .column.col-12.my-2
      cite.text-small O período considerado vai de #[b {{ report.period.firstDate | date('DD/MM/YYYY') }}] até #[b {{ report.period.lastDate | date('DD/MM/YYYY') }}]
  .flex-centered.content-full-height(v-else-if="error") #[error-box(:error="error")]
</template>

<script>
import videoWatchs from '@/services/api/videoWatchs'
import MostViewedCard from './components/MostViewedCard'
import RetentionCard from './components/RetentionCard'
import WatchedTimeCard from './components/WatchedTimeCard'

export default {
  data() {
    return {
      report: null,
      loading: false,
      error: null,
    }
  },
  components: { MostViewedCard, RetentionCard, WatchedTimeCard },
  methods: {
    async fetchReport() {
      try {
        this.loading = true
        const { data } = await videoWatchs.currentMonth()
        this.report = data
      } catch (e) {
        this.error = e
      } finally {
        this.loading = false
      }
    },
  },
  created() {
    this.fetchReport()
  },
}
</script>
